// Trips this device may open: trip id → { code, name, openedAt }. Proof of access is the 6-char code.
const KEY = "tga-trips";

export function listLocalTrips() {
  try { return JSON.parse(localStorage.getItem(KEY) || "{}"); } catch { return {}; }
}
export function rememberTrip({ id, code, name }) {
  if (!id || !code) return;
  const all = listLocalTrips();
  all[id] = { ...(all[id] || {}), code: code.toUpperCase(), name: name || all[id]?.name || "", openedAt: new Date().toISOString() };
  try { localStorage.setItem(KEY, JSON.stringify(all)); } catch (e) { console.error("remember trip failed", e); }
}
export function forgetTrip(id) {
  const all = listLocalTrips();
  delete all[id];
  try { localStorage.setItem(KEY, JSON.stringify(all)); } catch (e) { console.error("forget trip failed", e); }
}
export function tripCode(id) {
  return listLocalTrips()[id]?.code || null;
}
